import { IUser } from "@/models/user/User";
import ManagementService from "@/lib/services/management/ManagementService";
import axios from "axios";
import { create } from "zustand";

interface UserState {
    data: IUser | undefined,
    canAccessManagement: boolean,
    getData: () => Promise<boolean>,
    logout: () => Promise<boolean>
}

export const useUserStore = create<UserState>((set) => ({
    data: undefined,
    canAccessManagement: false,
    getData: async () => {
        try {
            const res = await axios.get(import.meta.env.VITE_API_URL + "auth/data", {
                withCredentials: true,
            });
            const userData = res.data.data as IUser;
            const canAccessManagement =
                userData?.Role === "Assistant"
                    ? await ManagementService.verifyAccess()
                    : false;
            set((state) => ({
                ...state,
                data: userData,
                canAccessManagement,
            }));
            return true;
        } catch (error) {
            set((state) => ({
                ...state,
                data: undefined,
                canAccessManagement: false,
            }));
            return false;
        }
    },
    logout: async () => {
        try {
            await axios.post(import.meta.env.VITE_API_URL + "auth/logout", {}, {
                withCredentials: true,
            });

            localStorage.removeItem('asset_borrowing');
            localStorage.removeItem('room_borrowing');            
            set((state) => ({
                ...state,
                data: undefined,
                canAccessManagement: false,
            }));
            return true
        } catch (error) {
            return false;
        }
    }
}))
